import { v4 as uuidv4 } from "uuid";

import catalogData from "assets/data/products";

import store from "../store";

function getImagesRelatedColor(catalog, article) {
    const productCatalog = catalog.find((product) => product.catalogId === article.catalogId);

    return productCatalog.images
        .filter((image) => image.carouselColor === article.color)
        .map((image) => image.url.replace("assets/", ""));
}

function groupArticlesByProduct(articles) {
    return articles.reduce((groups, article) => {
        const key = `${article.catalogId}::${article.color}`;
        if (!groups.has(key)) {
            groups.set(key, []);
        }
        groups.get(key).push(article);
        return groups;
    }, new Map());
}

function buildGroupedBatPayload(group, images, idBat) {
    const firstArticle = group[0];

    return {
        id: firstArticle.id,
        catalogId: firstArticle.catalogId,
        designation: firstArticle.designation,
        color: firstArticle.color,
        finishing: firstArticle.finishing,
        customization: firstArticle.customization,
        bat_imageLocation: firstArticle.bat_imageLocation,
        grammage: firstArticle.grammage,
        references: group.map((article) => article.reference),
        sizes: group.map((article) => ({
            size: article.size,
            quantity: article.quantity,
        })),
        images,
        // eslint-disable-next-line camelcase
        id_bat: idBat,
    };
}

export default class BatGenerator {
    constructor(idGenerator = { generate: uuidv4 }, dispatcher = store, catalog = catalogData) {
        this.idGenerator = idGenerator;
        this.dispatcher = dispatcher;
        this.catalog = catalog;
    }

    generate(articles) {
        const groups = groupArticlesByProduct(articles);

        Array.from(groups.values()).forEach((group) => {
            const idBat = this.idGenerator.generate();
            const images = getImagesRelatedColor(this.catalog, group[0]);
            const batPayload = buildGroupedBatPayload(group, images, idBat);

            group.forEach((article) => {
                article.id_bat = idBat;
            });

            this.dispatcher.dispatch("project/generateArticleBat", batPayload);
        });

        return articles;
    }
}
